import React from "react";
import { Grid, Stack, TextField, Typography } from "@mui/material";

interface LabeledNumberProps {
  label: string;
  value: string | number;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  helperText?: string;
  min?: number;
  max?: number;
  step?: number;
}

export const LabeledNumber: React.FC<LabeledNumberProps> = ({
  label,
  value,
  onChange,
  helperText,
  min,
  max,
  step,
}) => {
  const numericValue = value === "" ? "" : Number(value);

  return (
    <Grid item xs={12}>
      <Stack gap={1}>
        <TextField
          label={label}
          type="number"
          value={numericValue}
          onChange={onChange}
          fullWidth
          inputProps={{ min, max, step }}
        />
        {helperText && (
          <Typography
            variant="inputLabel"
            sx={{ color: "var(--grey-600, #798397)", fontWeight: 400 }}
          >
            {helperText}
          </Typography>
        )}
      </Stack>
    </Grid>
  );
};

export default LabeledNumber;
